import { type z } from 'zod';

import { unitySearchParams } from '@@containers/Search/unitySearchParams';

export const teamListSearchParams = unitySearchParams.pick({ q: true, leagueIds: true });

export type TeamListSearchParams = z.output<typeof teamListSearchParams>;
